class LinkCardCommon {
  // Local storage key for the LinkCard alignment preference.
  static linkCardAlignmentPrefKey = 'aha-editor.linkCard.alignment';
  // Local storage key for the LinkCard orientation preference.
  static linkCardOrientationPrefKey = 'aha-editor.linkCard.orientation';
  // Local storage key for the LinkCard fullWidth preference.
  static linkCardFullWidthPrefKey = 'aha-editor.linkCard.fullWidth';
  // Local storage key for the LinkCard keepRatio preference.
  static linkCardKeepRatioPrefKey = 'aha-editor.linkCard.keepRatio';
}

export default LinkCardCommon;
